import { render, staticRenderFns } from "./WechatActivitySign.vue?vue&type=template&id=f1c37e20&scoped=true&"
import script from "./WechatActivitySign.vue?vue&type=script&lang=js&"
export * from "./WechatActivitySign.vue?vue&type=script&lang=js&"
import style0 from "./WechatActivitySign.vue?vue&type=style&index=0&id=f1c37e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c37e20",
  null
  
)

export default component.exports